module.exports = __webpack_public_path__ + "img/ic_runner_up.dc6e9dc3.svg";